module.exports = __webpack_public_path__ + "static/media/productTypeComercial.c389341b.svg";